<template>
    <div>
        <van-search
                placeholder="请输入小区名称"
                show-action
                shape="round"
                @search="onSearch"
                @cancel="onCancel"
                v-model="keywords"
                style="background-color: dodgerblue">
        </van-search>
        <!-- 选择框对应的下拉list -->
        <van-cell-group class="regionList" v-if="searchShow">
            <van-cell
                    v-for="item in regions"
                    :key="item.regionNo"
                    :title="item.regionName"
                    @click="regionListClick(item)"
            />
        </van-cell-group>
    </div>
</template>

<script>
    import {Search} from 'vant'
    import {regions} from '@/api/maintainFund/maintainFund'

    export default {
        name: 'Regions',
        components: {
            VanSearch: Search
        },
        data() {
            return {
                divisionCode: '',
                avgPrice: '',
                houseHold: '',
                regions: [],
                currentPage: 1,
                pageCount: 1,
                pageSize: 2,
                keywords: '',
                searchShow: false
            };
        },
        methods: {
            onCancel: function () {
                this.$router.go(-1);
            },
            onSearch: function () {
                const toast = this.$toast.loading({
                    duration: 0,       // 持续展示 toast
                    forbidClick: true, // 禁用背景点击
                    loadingType: 'spinner',
                    message: '加载中...'
                });
                let param = {
                    regionName: this.keywords
                };
                regions(param).then(response => {
                    this.regions = response.data;
                    this.searchShow = true;
                    toast.clear();
                })
            },
            regionListClick: function (region) {
                this.$router.push({path: '/maintainFund/bindingHouse', query: {region: region, label: decodeURI(this.$route.query.label)}})
            }
        }
    }
</script>